import Button from "components/shared/button";
import { QuantityWidgetWrapper } from "./QuantityWidgetWrapper";

export const FixedNumberQuantityWidget: React.FC<{
  isSelected?: boolean;
  quantity: number;
  onToggle: () => void;
  disabled?: boolean;
}> = ({ isSelected, quantity, onToggle, disabled = false }) => {
  return (
    <QuantityWidgetWrapper isSelected={isSelected}>
      <text data-text-align="center" data-length="auto">
        {quantity}
      </text>
      {!disabled &&
        <Button
          onClick={onToggle}
          micro
          outline
          disabled={disabled}
          icon={isSelected ? "delete" : "shopping_cart"}
        />
      }
    </QuantityWidgetWrapper>
  );
};
